import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MerchandiseImages from '../images/merchandise';
import MainLayout from '../layout/MainLayout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/Button';

function AboutMerchandise() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center container mx-auto lg:h-screen lg:mt-8 mt-32">
      <div className="flex flex-col lg:flex-row w-10/12 gap-12 items-center">
        <img
          src={MerchandiseImages.Merchandise}
          alt="ilustrasi merchandise"
          className="lg:my-0 lg:w-1/2 w-4/5 duration-700 relative transform opacity-0 transition-all translate-y-12 ease-out animation-slide-up"
        />
        <div className="flex flex-col justify-center">
          <h1 className="text-primary text-3xl lg:text-5xl font-bold duration-700 relative transform opacity-0 transition-all translate-y-12 ease-out animation-slide-up">
            Merchandise
          </h1>
          <p className="text-secondary text-justify mt-8 font-medium duration-700 relative transform opacity-0 transition-all translate-y-12 ease-out animation-slide-up">
            {t('merchandise.description')}
          </p>
        </div>
      </div>
    </div>
  );
}

function ProductCard({
  name, link, image, price,
}) {
  return (
    <div className="lg:w-72 w-48-percent flex flex-col">
      <img src={image} alt="totebag" className="rounded-lg" />
      <h1 className="text-primary font-bold my-1 text-md">{ name }</h1>
      <div className="flex items-center justify-between mt-auto gap-4">
        <Link to={link} target="_blank" className="w-max">
          <Button className="w-max justify-center rounded-lg lg:rounded-full">
            Buy now
          </Button>
        </Link>
        <div className="text-secondary">
          <small>{price}</small>
        </div>
      </div>
    </div>
  );
}

ProductCard.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

function Products() {
  const products = [
    {
      name: 'Tumblr “Be Grateful Today, Steady Tomorrow” (black/tosca)',
      link: 'https://api.whatsapp.com/send/?phone=6285103209515',
      image: MerchandiseImages.Product1,
      price: 'Rp149.000',
    },
    {
      name: 'Tumblr “I Matter” (pink)',
      link: 'https://api.whatsapp.com/send/?phone=6285103209515',
      image: MerchandiseImages.Product2,
      price: 'Rp149.000',
    },
  ];

  return (
    <div className="w-10/12 lg:w-880 xl:w-full xl:max-w-5xl mx-auto flex flex-wrap mt-12 pb-8 gap-y-8 gap-x-8">
      {
        products.map((item) => (
          <ProductCard name={item.name} link={item.link} image={item.image} price={item.price} />
        ))
      }
    </div>
  );
}

function Merchandise() {
  function callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('translate-y-0', 'opacity-100');
        entry.target.classList.remove('translate-y-12', 'opacity-0');
      }
    });
  }

  const observer = new IntersectionObserver(callback);

  useEffect(() => {
    const replacers = document.querySelectorAll('.animation-slide-up');
    for (let i = 0; i < replacers.length; i += 1) {
      observer.observe(replacers[i]);
    }
  }, []);

  return (
    <MainLayout>
      <Header page="Merchandise" />
      <AboutMerchandise />
      <Products />
      <Footer />
    </MainLayout>
  );
}

export default Merchandise;
